export default __webpack_public_path__ + "static/media/mountain-right.ac24e2ae.svg";